export default __webpack_public_path__ + "static/speedup-healing-3592a7492b31f5e4236283a00d1ce7ec.svg";